<template>
  <div>
    <custom-page-form />
  </div>
</template>

<script>
import CustomPageForm from './components/CustomPageForm'
export default {
  name: 'CustomPageAdd',
  components: { CustomPageForm }
}
</script>
